<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <div v-show="showModalBeneficiaries">
      <Modal :widthContainer="'70%'" :heightContainer="'70% !important'">
        <div slot="body">
          <div class="">
            <form @submit="addBeneficiarie">
              <div class="grid grid-cols-1 gap-4">
                <p class="personalInfoTitle">Agregar Beneficiario</p>
                <div class="mb-4" style="margin-top:10px;">
                  <input class="inputsForm capitalize" id="input_name" style="width:100%;" type="text" v-model.trim="$v.name_beneficiarie.$model"
                    :class="{'inputs-invalid-form':$v.name_beneficiarie.$error, 'inputsForm':!$v.name_beneficiarie.$invalid}" 
                    @keyup="validateSpecialCharacters('name_beneficiarie')" placeholder="Nombre" />
                  <div class="content-text">
                    <div v-if="$v.name_beneficiarie.$error" class="text" style="width:100%;">
                      <span class="errors" v-if="!$v.name_beneficiarie.required">El nombre es requerido</span>
                      <span class="errors" v-if="!$v.name_beneficiarie.minLength">Debe ingresar más de 2 caracteres en el nombre</span>
                      <span class="errors" v-if="!$v.name_beneficiarie.maxLength">Debe ingresar máximo 30 caracteres en el nombre</span>
                    </div>
                  </div>
                </div>
                <!-- <div class="mb-4">
                  <input class="inputsForm capitalize" id="input_middle_name" style="width:100%;" type="text" v-model="middle_name_beneficiarie" 
                  @keyup="validateSpecialCharacters('middle_name_beneficiarie')" placeholder="Segundo Nombre">
                </div> -->
                <div class="mb-4">
                  <input class="inputsForm capitalize" id="input_paternal_name" style="width:100%;" type="text" v-model.trim="$v.paternal_name_beneficiarie.$model" 
                    :class="{'inputs-invalid-form':$v.paternal_name_beneficiarie.$error, 'inputsForm':!$v.paternal_name_beneficiarie.$invalid}"
                    @keyup="validateSpecialCharacters('paternal_name_beneficiarie')" placeholder="Apellido Paterno">
                  <div class="content-text">
                    <div v-if="$v.paternal_name_beneficiarie.$error" class="text" style="width:100%;">
                      <span class="errors" v-if="!$v.paternal_name_beneficiarie.minLength">Debe ingresar más de 2 caracteres en el apellido paterno</span>
                      <span class="errors" v-if="!$v.paternal_name_beneficiarie.maxLength">Debe ingresar máximo 30 caracteres en el apellido paterno</span>
                    </div>
                  </div>
                </div>
                <div class="mb-4">
                  <input class="inputsForm capitalize" id="input_maternal_name" style="width:100%;" type="text" v-model.trim="maternal_name_beneficiarie" 
                    :class="{'inputs-invalid-form':$v.maternal_name_beneficiarie.$error, 'inputsForm':!$v.maternal_name_beneficiarie.$invalid}"
                    @keyup="validateSpecialCharacters('maternal_name_beneficiarie')" placeholder="Apellido Materno">
                  <div class="content-text">
                    <div v-if="$v.maternal_name_beneficiarie.$error" class="text" style="width:100%;">
                      <span class="errors" v-if="!$v.maternal_name_beneficiarie.minLength">Debe ingresar más de 2 caracteres en el apellido materno</span>
                      <span class="errors" v-if="!$v.maternal_name_beneficiarie.maxLength">Debe ingresar máximo 30 caracteres en el apellido materno</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:grid md:grid-cols-2 grid grid-cols-1 gap-4">
                <div class="mb-4" style="">
                  <select class="inputsForm" id="input_kinship" style="width:100%;" v-model.trim="$v.kinship_beneficiarie.$model"
                    :class="{'inputs-invalid-form':$v.kinship_beneficiarie.$error, 'inputsForm':!$v.kinship_beneficiarie.$invalid}">
                    <option value="Parentesco" selected hidden>Parentesco</option>
                    <option value="Conyuge">Conyuge</option>
                    <option value="Hijo">Hijo</option>
                    <option value="Padre">Padre</option>
                    <option value="Madre">Madre</option>
                    <option value="Hermano">Hermano</option>
                    <option value="Abuelo">Abuelo</option>
                    <option value="Tio">Tio</option>
                    <option value="Pareja">Pareja</option>
                    <option value="Sobrino">Sobrino</option>
                    <option value="otro">Otro</option>
                  </select>
                  <div class="content-text">
                    <div v-if="$v.kinship_beneficiarie.$error" class="text" style="width:100%;">
                      <span class="errors" v-if="!$v.kinship_beneficiarie.isUnique">El parentesco es requerido</span>
                    </div>
                  </div>
                </div>
                <div class="mb-4 md:grid md:grid-cols-2 grid grid-cols-1">
                  <div style="display: table;">
                    <div style="display: table-cell;vertical-align: middle;">
                      <label for="">Porcentaje</label>
                    </div>
                  </div>
                  <div class="input-group mb-4 grid grid-cols-1">
                    <div class="input-group">
                      <input type="number" class="inputsForm" id="input_percentage" v-model.trim="$v.percentage_beneficiarie.$model" style="width:100%"
                      :class="{'inputs-invalid-form':$v.percentage_beneficiarie.$error, 'inputsForm':!$v.percentage_beneficiarie.$invalid}"
                      onKeyPress="if(this.value.length==3) return false;" v-on:change="percentage_beneficiarie=changePercentage(percentage_beneficiarie)" />
                      <span tabIndex="-1" class="input-group-addon" style="">%</span>
                    </div>
                    <div class="">
                      <div class="content-text">
                        <div v-if="$v.percentage_beneficiarie.$error" class="text" style="width:100%;">
                          <span class="errors" v-if="!$v.percentage_beneficiarie.required">El porcentaje es requerido</span>
                          <span class="errors" v-if="!$v.percentage_beneficiarie.between">El porcentaje debe estar entre 
                            {{$v.percentage_beneficiarie.$params.between.min}} y {{$v.percentage_beneficiarie.$params.between.max}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top:20px;">
                <Date ref="dateComponent" description="Fecha de nacimiento:"
                  :day="birthdate_day_beneficiarie" :month="birthdate_month_beneficiarie" 
                  :year="birthdate_year_beneficiarie"
                  v-on:get-complete-date-selected="getResponseDate($event)" />
              </div>
              <div class="grid grid-cols-1 gap-4" style="margin-top:50px;">
                <div>
                  <button class="AccessButton" id="button_save">Agregar</button>
                </div>
              </div>
              <div class="grid grid-cols-1 gap-4" style="margin-top:10px;">
                <div>
                  <input type="button" value="Cancelar" id="button_cancel" v-on:click="cancelModifyBeneficiarie()" class="AccessButtonWithoutBackground">        
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
    <div style="margin-top:30px;">
      <Access ref="accessComponent" v-on:search-info-by-rfc-nip="getResponseAccess($event)"
        description="Ingresar los 13 caracteres del R.F.C. y tu NIP para realizar el tramite." :showForm="showFormAccess" />
    </div>
    <form @submit="register">
      <div style="margin-top:30px;" v-if="rfcIsValid">
        <div>
          <PersonalInfo title="Datos personales del Socio" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfcToShow" />
        </div>
        <div class="content-text" style="margin-top:30px;" v-if="hasPendingRequest">
          <div class="text">
            <p class="personalInfoValue">
            La solicitud ya ha sido creada. Para continuar con el proceso favor de adjuntar el 
            documento Solicitud de Actualización de Beneficiarios firmado.</p>
          </div>
        </div>
        <div style="margin-top:20px;">
          <div class="mb-4" style="margin-top:10px;">
            <label for="" class="titleInputs">Correo:</label><br/>
            <input class="inputsForm" id="input_email" type="text" v-model.trim="$v.email.$model" 
              :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" 
              :disabled="hasPendingRequest || hasUploadedDocumentRequest" placeholder="Correo Electrónico del Titular" />
            <div class="content-text">
              <div v-if="$v.email.$error" class="text">
                <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:30px;" class="">
          <p class="titleComponent">Beneficiarios Actuales</p>
          <div style="margin-top:10px;" class="container-beneficiaries" v-for="item in list_beneficiaries" :key="item.id">
            <div class="items-beneficiaries md:grid md:grid-cols-12 grid grid-cols-1 gap-4;">
              <div class="md:col-span-8 md:text-left text-center" style="display: table;">
                <div style="display: table-cell;vertical-align: middle;">
                  <p style="font-family:Roboto;font-size:18px;font-weight:700;color:#222222;">{{item.nombre | camelize}} {{item.paterno | camelize}} {{item.materno | camelize}}</p>
                  <p style="font-family:Roboto;font-size:15px;font-weight:400;color:#222222;">{{item.parentesco}}, {{item.fecha_nacimiento | dateToLetters}}</p>
                </div>
              </div>
              <div style="display: table;" class="md:col-span-2 md:mt-0 mt-8">
                <div style="display: table-cell;vertical-align: middle;">
                  <p style="font-family:Roboto;font-size:22px;font-weight:500;color:#198F99;">{{item.porcentaje | percent}}</p>
                  <p style="font-family:Roboto;font-size:15px;font-weight:400;color:#222222;">Beneficio</p>
                </div>
              </div>
              <div style="display: table;" class="md:col-span-2 md:mt-0 mt-8">
                <div style="display: table-cell;vertical-align: middle;">
                  <input type="button" class="actionButtonBorder" id="button_edit" v-on:click="editBeneficiarie(item.id)" v-if="!hasPendingRequest && !hasUploadedDocumentRequest" value="Editar" />
                  <input type="button" class="actionButtonBorder" id="button_delete" v-on:click="removeBeneficiarie(item.id)" style="margin-top:10px;" v-if="!hasPendingRequest && !hasUploadedDocumentRequest" value="Eliminar" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:20px;" v-if="requestTutor">
          <div class="mb-4" style="margin-top:10px;">
            <label for="" class="titleInputs">Tutor:</label><br/>
            <input class="inputsForm capitalize" id="input_tutor" type="text" v-model.trim="$v.tutor.$model" 
              :class="{'inputs-invalid-form':$v.tutor.$error, 'inputsForm':!$v.tutor.$invalid}" 
              :disabled="hasPendingRequest || hasUploadedDocumentRequest"
              @keyup="validateSpecialCharacters('tutor')" placeholder="Nombre Completo" />
            <div class="content-text">
              <div v-if="$v.tutor.$error" class="text">
                <span class="errors" v-if="!$v.tutor.required">El nombre completo del tutor es requerido</span>
                <span class="errors" v-if="!$v.tutor.minLength">Debe ingresar más de 2 caracteres en el nombre completo del tutor</span>
                <span class="errors" v-if="!$v.tutor.maxLength">Debe ingresar máximo 100 caracteres en el nombre completo del tutor</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center" style="margin-top:20px;" v-if="hasPendingRequest || hasUploadedDocumentRequest">
          <div class="container-delete-request flex justify-end">
            <div>
              <input type="button" class="actionButtonBorder" id="button_delete_request" v-on:click="cancelRequest()" value="Eliminar Solicitud">
            </div>
          </div>
        </div>
        <div class="flex justify-center" style="margin-top:20px;" v-if="hasPendingRequest">
          <div class="container-delete-request flex justify-center">
            <div class="grid grid-cols-3 gap-4 w-full">
              <div class="col-span-2">
                <div class="mb-4">
                  <input class="inputsForm italic" id="input_document_name" style="width:100%;height:40px;" type="text" v-model="documentName" 
                    placeholder="Nombre del archivo" disabled>
                </div>
              </div>
              <div>
                <input type="button" v-if="base64File == ''" value="Cargar Archivo" id="button_file_upload" style="height:40px;" class="loadDocumentButton" v-on:click="getFile('input_file_upload')">
                <input type="button" v-if="base64File != ''" value="Eliminar Archivo" id="button_file_delete" style="height:40px;" class="deleteDocumentBeneficiarieButton" v-on:click="deleteDocument()"><br/>
                <div style='height: 0px;width:0px; overflow:hidden;'><input id="input_file_upload" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event)"/></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top:30px;" v-if="rfcIsValid">
        <div v-if="!hasPendingRequest && !hasUploadedDocumentRequest">
          <p style="font-family:Roboto;font-size:26px;font-weight:400;color:#222222;">Total: <span style="font-weight:700;color:#198F99;">{{getTotalPercentage() | percent}}</span></p>
        </div>
        <div v-if="!hasPendingRequest && !hasUploadedDocumentRequest">
          <p style="font-family:Roboto;font-size:26px;font-weight:400;color:#222222;">Restante: <span style="font-weight:700;color:#198F99;">{{getRemainingPercentage() | percent}}</span></p>
        </div>
        <div style="margin-top:20px;" v-if="!hasPendingRequest && !hasUploadedDocumentRequest">
          <input type="button" class="actionButton2" id="button_add" value="Agregar Otro Beneficiario" v-on:click="openModal()">
        </div>
      </div>
      <div style="margin-top:30px;" v-if="rfcIsValid && getTotalPercentage() < 100">
        <div>
          <p class="titleComponent">Completa tus beneficiarios</p>
          <p class="description md:text-center text-left">Antes de registrar la solicitud de cambio de beneficiario es necesario cubrir el 100% de los asegurados.</p>
        </div>
      </div>
      <div style="margin-top:30px;" v-if="rfcIsValid && getTotalPercentage() == 100">
        <div v-if="!hasPendingRequest && !hasUploadedDocumentRequest">
          <p class="titleComponent">Beneficiarios Completos</p>
          <p class="description md:text-center text-left">Una vez completado el 100% de los beneficiarios podrás descargar la solicitud del cambio de Beneficiarios para su firma.</p>
        </div>
      </div>
      <div style="margin-top:30px;" v-if="rfcIsValid">
        <div class="" v-show="!hasPendingRequest && !hasUploadedDocumentRequest">
          <button class="AccessButton" id="button_save_all" :disabled="getTotalPercentage() < 100">Registrar Solicitud</button>
        </div>
        <div class="" v-show="hasPendingRequest">
          <input type="button" class="AccessButton" id="button_save_document" value="Cargar Solicitud Firmada" v-on:click="uploadFile()" />
        </div>
        <div style="margin-top:10px">
          <div>
            <input type="button" value="Atrás" v-on:click="goBack()" class="AccessButtonWithoutBackground" id="backButton" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {getDaysByYearAndMonth, getMonthsOfYear, getRangeOfYears, createDateStringByYearMonthDay, 
        getAge, isUnderAge, compareTwoDates} from '@/helpers/dates'
import {numericMonths, largeMonths} from '@/helpers/enums'
import {sendMailNotificationClient, bodyEmailNotificationClient, validateEmail} from '@/helpers/email'
import {required, minLength, maxLength, email, between, requiredIf} from 'vuelidate/lib/validators'

import Swal from 'sweetalert2'
import Loading from '@/components/Loading/Loading.vue'
import Modal from '@/components/Modal/Modal.vue'
import Access from '@/components/Forms/Access.vue'
import Date from '@/components/Forms/Date.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'

import User from '@/classes/User'
import Beneficiarie from '@/classes/Beneficiarie'

import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      isLoading: false,
      rfc: "",
      rfcToShow: "",
      rfcIsValid: false,
      name: "",
      maternalName: "",
      paternalName: "",
      email: "",
      nip: "",
      token_auth: "",
      userObjectClass: null,
      beneficiarieObjectClass: null,
      showModalBeneficiaries: false,
      dayList: [],
      monthList: [],
      yearList: [],
      id_beneficiarie: 0,
      name_beneficiarie: "",
      middle_name_beneficiarie: "",
      paternal_name_beneficiarie: "",
      maternal_name_beneficiarie: "",
      kinship_beneficiarie: "Parentesco",
      birthdate_day_beneficiarie: "Día",
      birthdate_month_beneficiarie: "Mes",
      birthdate_year_beneficiarie: "Año",
      birthdate_beneficiarie: "",
      percentage_beneficiarie: "",
      list_beneficiaries: [],
      tutor: "",
      requestTutor: false,
      headLineBirthdate: "",
      hasPendingRequest: false,
      hasUploadedDocumentRequest: false,
      documentName: "",
      base64File: "",
      requestId: 0,
      showFormAccess: true,
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  components: {
    Loading,
    Modal,
    Access,
    Date,
    PersonalInfo
  },
  validations: {
    tutor: {
      required: requiredIf(function() {
        if (this.requestTutor && !this.showModalBeneficiaries)
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(100)
    },
    email: {
      required: requiredIf(function() {
        if (!this.showModalBeneficiaries)
          return true;
        return false;
      }),
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    name_beneficiarie: {
      required:requiredIf(function() {
        if (this.showModalBeneficiaries)
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    paternal_name_beneficiarie: {
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    maternal_name_beneficiarie: {
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    kinship_beneficiarie: {
      required:requiredIf(function() {
        if (this.showModalBeneficiaries)
          return true;
        return false;
      }),
      isUnique(value) {
        if (value == "Parentesco")
          return false;
        return true;
      }
    },
    percentage_beneficiarie: {
      required:requiredIf(function() {
        if (this.showModalBeneficiaries)
          return true;
        return false;
      }),
      between: between(1, 100)
    }
  },
  name: 'CaptureBeneficiariesComponent',
  async mounted() {
    this.userObjectClass = new User();
    this.beneficiarieObjectClass = new Beneficiarie();
    this.login();
    this.getYears();
  },
  beforeMount() {
    Array.prototype.max = function() {
      return Math.max.apply(null, this);
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
        console.log("token: ", this.token_auth);
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    validateSpecialCharacters(field) {
      var regex = /^[a-zA-ZÀ-ÿ]+$/;
      if (regex.test(this[field]) != true) {
        this[field] = this[field].replace(/[^a-zA-ZÀ-ÿ@\s]+/, '');
      }
    },
    areSurNamesEmpty() {
      if (this.paternal_name_beneficiarie == "" && this.maternal_name_beneficiarie == "") {
        return true;
      }

      return false;
    },
    getYears() {
      this.yearList = getRangeOfYears(100);
    },
    generateMonthsAndDays(year, month) {
      if (year != "Año") {
        this.monthList = getMonthsOfYear(year);
      }

      if (year != "Año" && month != "Mes") {
        this.dayList = getDaysByYearAndMonth(year, numericMonths[month]); 
      }

      if (this.birthdate_day_beneficiarie != "Día") {
        if (!this.dayList.includes(this.birthdate_day_beneficiarie)) {
          this.birthdate_day_beneficiarie = "Día";
        }
      }

      if (this.birthdate_month_beneficiarie != "Mes") {
        if (!this.monthList.includes(this.birthdate_month_beneficiarie)) {
          this.birthdate_month_beneficiarie = "Mes";
        }
      }
    },
    getCompleteDateSelected(year, month, day) {
      return createDateStringByYearMonthDay(year, numericMonths[month], day);
    },
    getResponseAccess(event) {
      if (event.rfcIsValid) {
        this.setAuthenticatedUserInformation(event.data)
        this.getPendingRequest();
      }
      this.rfcIsValid = event.rfcIsValid;
    },
    setAuthenticatedUserInformation(userAuthenticated) {
      this.name = userAuthenticated.name;
      this.paternalName = userAuthenticated.paternal_name;
      this.maternalName = userAuthenticated.maternal_name;
      this.rfcToShow = userAuthenticated.rfc;
      this.headLineBirthdate = userAuthenticated.birthday;
    },
    getPendingRequest() {
      return this.beneficiarieObjectClass.getPendingRequest(this.token_auth, this.rfcToShow).then(response => {
        console.log("pending request: ", response);
        if (response.data.response.requests == null) {
          this.hasPendingRequest = false;
          this.requestId = 0;
          this.getUploadedDocumentRequest();
        } else {
          this.hasPendingRequest = true;
          this.requestId = response.data.response.requests[0].id;
          this.fillListBeneficiaries(response.data.response.requests[0], false);
        }
        this.showFormAccess = false;
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getBeneficiaries() {
      this.beneficiarieObjectClass.getBy({
        token_auth: this.token_auth,
        rfc: this.rfcToShow,
        name: this.name,
        middle_name: "",
        paternal_name: this.paternalName,
        maternal_name: this.maternalName
      }).then(response => {
        this.fillListBeneficiaries(response.data.response.data, true);
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getUploadedDocumentRequest() {
      this.beneficiarieObjectClass.getUploadedDocumentRequest(this.token_auth, this.rfcToShow).then(response => {
        if (response.data.response.data.length <= 0) {
          this.hasUploadedDocumentRequest = false;
          this.requestId = 0;
          this.getBeneficiaries();
        } else {
          this.hasUploadedDocumentRequest = true;
          this.requestId = response.data.response.data[0].id;
          this.fillListBeneficiaries(response.data.response.data[0], false);
        }
      }).catch(error => {
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    fillListBeneficiaries(beneficiaries, isCurrentBeneficiaries) {
      this.list_beneficiaries = [];
      let beneficiariesLength = isCurrentBeneficiaries ? beneficiaries.length : beneficiaries.beneficiaries_list_json.length;
      for (let i = 0; i < beneficiariesLength; i++) {
        var json = {
          id: this.list_beneficiaries.length + 1,
          paterno: isCurrentBeneficiaries ? beneficiaries[i].paterno : beneficiaries.beneficiaries_list_json[i].paternal_name,
          materno: isCurrentBeneficiaries ? beneficiaries[i].materno : beneficiaries.beneficiaries_list_json[i].maternal_name,
          nombre: isCurrentBeneficiaries ? beneficiaries[i].nombre : beneficiaries.beneficiaries_list_json[i].name,
          fecha_nacimiento: isCurrentBeneficiaries ? beneficiaries[i].fecha_nacimiento : beneficiaries.beneficiaries_list_json[i].birth_date,
          porcentaje: isCurrentBeneficiaries ? beneficiaries[i].porcentaje : beneficiaries.beneficiaries_list_json[i].porcentage,
          parentesco: isCurrentBeneficiaries ? beneficiaries[i].parentesco : beneficiaries.beneficiaries_list_json[i].relationship,
        };

        this.list_beneficiaries.push(json); 
      }

      if (!isCurrentBeneficiaries) {
        this.email = beneficiaries.email;
        if (beneficiaries.tutor != "") {
          this.requestTutor = true;
          this.tutor = beneficiaries.tutor;
        } else {
          this.requestTutor = false;
        }
      }
    },
    validateNIP() {
      var input = document.getElementById('input_no_debt_certificate_nip');

      var regex = /^([0-9])*$/
      var result = regex.test(input.value)
      input.oninvalid = input.setCustomValidity('');
      if(!result){
        input.value = input.value.toString().slice(0, -1)
      }
      if(input.value.length < 4){
        input.oninvalid = input.setCustomValidity('Favor de introducir el NIP a 4 digitos.');
      }
    },
    isInvalidPrincipalForm() {
      this.$v.email.$touch();
      this.$v.tutor.$touch();

      if (!this.$v.email.$invalid && !this.$v.tutor.$invalid) {
        return false;
      }

      return true;
    },
    isInvalidBeneficiarieForm() {
      this.$v.name_beneficiarie.$touch();
      this.$v.paternal_name_beneficiarie.$touch();
      this.$v.maternal_name_beneficiarie.$touch();
      this.$v.kinship_beneficiarie.$touch();
      this.$v.percentage_beneficiarie.$touch();
      this.$refs.dateComponent.$v.$touch()

      if (!this.$v.name_beneficiarie.$invalid && !this.$v.paternal_name_beneficiarie.$invalid 
          && !this.$v.maternal_name_beneficiarie.$invalid && !this.$v.kinship_beneficiarie.$invalid 
          && !this.$v.percentage_beneficiarie.$invalid
          && !this.$refs.dateComponent.$v.$invalid) {
            return false;
      }

      return true;
    },
    addBeneficiarie(e) {
      e.preventDefault();

      if (!this.isInvalidBeneficiarieForm()) {
        this.isLoading = true

        if (this.areSurNamesEmpty()) {
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: "Favor de llenar por lo menos un apellido",
            icon: "warning",
          });
          this.isLoading = false;
          return false;
        }

        let hasErrors = this.validateKinship(this.kinship_beneficiarie, this.getCompleteDateSelected(this.birthdate_year_beneficiarie, this.birthdate_month_beneficiarie, this.birthdate_day_beneficiarie), this.headLineBirthdate);

        if (hasErrors){
          this.isLoading = false;
          return;
        }

        let beneficiarie = {
          id: this.id_beneficiarie == 0 ? this.getMaxIdBeneficiarie() + 1 : this.id_beneficiarie,
          paterno: this.camelize(this.paternal_name_beneficiarie.trim()),
          materno: this.camelize(this.maternal_name_beneficiarie.trim()),
          nombre: this.camelize(this.name_beneficiarie.trim()),
          /*lastName: this.middle_name_beneficiarie != "" ? this.middle_name_beneficiarie.trim() : this.middle_name_beneficiarie,*/
          fecha_nacimiento: this.birthdate_beneficiarie,
          porcentaje: this.percentage_beneficiarie,
          parentesco: this.kinship_beneficiarie
        }

        let beneficiarieAlreadyExist = this.beneficiarieObjectClass.beneficiarieAlreadyExist(this.list_beneficiaries, beneficiarie);

        if (beneficiarieAlreadyExist.exist) {
          if (this.id_beneficiarie != beneficiarieAlreadyExist.id) {
            Swal.fire({
              title: "Aviso",
              customClass: {
                container: 'my-swal'
              },
              text: "El beneficiario coincide con la información de otro beneficiario ya capturado, favor de validar los datos",
              icon: "warning",
            });
            this.isLoading = false
            return;
          }
        }

        let addBeneficiariee = true;
        if(this.getPercentageBeneficiarie(beneficiarie.id) > 100){
          addBeneficiariee = false;
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: "El porcentaje entre todos los beneficiarios debe ser 100%",
            icon: "warning",
          });
          this.isLoading = false
        }

        if(addBeneficiariee){
          this.isLoading = false
          if (this.id_beneficiarie != 0) {
            this.modifyBeneficiarieList(beneficiarie);
          } else {
            this.list_beneficiaries.push(beneficiarie);
          }
          this.validateIfThereIsaMinorBeneficiarie();
          this.cleanControlsBeneficiariesInModalWindow();
          this.showModalBeneficiaries = false;
        }
      }
    },
    validateKinship(kinship, beneficiarieBirthDate, userBirthDate) {
      let hasErrors = false;
      let isGreater = false;

      if (kinship.toUpperCase() == 'HIJO') {
        isGreater = compareTwoDates(userBirthDate, beneficiarieBirthDate);

        if (isGreater) {
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: `La Fecha de Nacimiento del Parentesco ${kinship} No puede ser menor que la Fecha de Nacimiento del Titular`,
            icon: "warning",
          });

          hasErrors = true;
        }
      }

      if (kinship.toUpperCase() == "PADRE" || kinship.toUpperCase() == "MADRE" || kinship.toUpperCase() == "ABUELO") {
        isGreater = compareTwoDates(beneficiarieBirthDate, userBirthDate);

        if (isGreater) {
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: `La Fecha de Nacimiento del Parentesco ${kinship} No puede ser mayor que la Fecha de Nacimiento del Titular`,
            icon: "warning",
          });

          hasErrors = true;
        }
      }

      return hasErrors;
    },
    validateIfThereIsaMinorBeneficiarie() {
      if (this.list_beneficiaries.length > 0) {
        for (let i = 0; i < this.list_beneficiaries.length; i++) {
          let age = getAge(this.list_beneficiaries[i].fecha_nacimiento);
          console.log(age);
          console.log("es menor de edad? ", isUnderAge(age, 18));
          if (isUnderAge(age, 18)) {
            this.requestTutor = true;
            break;
          } else {
            this.requestTutor = false;
          }
        }

        if (!this.requestTutor) {
          this.tutor = "";
        }
      }
    },
    modifyBeneficiarieList(beneficiare){
      let index = this.list_beneficiaries.findIndex(b => b.id === beneficiare.id);
      this.list_beneficiaries[index] = beneficiare;
      console.log("new beneficiare: " + this.list_beneficiaries);
    },
    editBeneficiarie(beneficiarieId){
      var obj_beneficiarie = this.list_beneficiaries.filter(({id}) => id === beneficiarieId)[0];
      let birthDate = obj_beneficiarie.fecha_nacimiento.split('-');
      this.generateMonthsAndDays(birthDate[0], largeMonths[birthDate[1]]);
      if(obj_beneficiarie != null){
        this.id_beneficiarie = obj_beneficiarie.id
        this.paternal_name_beneficiarie = obj_beneficiarie.paterno
        this.maternal_name_beneficiarie = obj_beneficiarie.materno
        this.name_beneficiarie = obj_beneficiarie.nombre
        // this.middle_name_beneficiarie = obj_beneficiarie.lastName
        this.birthdate_year_beneficiarie = birthDate[0],
        this.birthdate_month_beneficiarie = largeMonths[birthDate[1]],
        this.birthdate_day_beneficiarie = birthDate[2],
        this.$refs.dateComponent.setDate(this.birthdate_day_beneficiarie, this.birthdate_month_beneficiarie, this.birthdate_year_beneficiarie)
        this.percentage_beneficiarie = obj_beneficiarie.porcentaje
        this.kinship_beneficiarie = obj_beneficiarie.parentesco;
      }
      this.showModalBeneficiaries = true;
    },
    getMaxIdBeneficiarie() {
      let idArray = []
      if (this.list_beneficiaries.length > 0) {
        for (let i = 0; i < this.list_beneficiaries.length; i++) {
          idArray.push(this.list_beneficiaries[i].id);
        }
      } else {
        return 0
      }

      let max = idArray.max()
      return max
    },
    getPercentageBeneficiarie(id) {
      console.log("id: ",id);
      var percentage = 0;
      if (this.list_beneficiaries.length > 0) {
        for (let objBeneficiarie of this.list_beneficiaries) {
          console.log("objBeneficiarie.id: ",objBeneficiarie.id);

          if(objBeneficiarie.id != id){
            percentage += parseInt(objBeneficiarie.porcentaje);
          }
        }
      }
      console.log("porcentaje: ",percentage);
      return percentage + parseInt(this.percentage_beneficiarie);
    },
    openModal() {
      this.cleanControlsBeneficiariesInModalWindow();
      this.showModalBeneficiaries = true;
    },
    cleanControlsBeneficiariesInModalWindow() {
      this.id_beneficiarie = 0;
      this.paternal_name_beneficiarie = "";
      this.maternal_name_beneficiarie = "";
      this.name_beneficiarie = "";
      // this.middle_name_beneficiarie = "";
      this.birthdate_day_beneficiarie = "Día";
      this.birthdate_month_beneficiarie = "Mes";
      this.birthdate_year_beneficiarie = "Año";
      this.birthdate_beneficiarie = "";
      this.percentage_beneficiarie = "";
      this.kinship_beneficiarie = "Parentesco";
      this.dayList = [];
      this.$v.name_beneficiarie.$reset();
      this.$v.paternal_name_beneficiarie.$reset();
      this.$v.maternal_name_beneficiarie.$reset();
      this.$v.kinship_beneficiarie.$reset();
      this.$v.percentage_beneficiarie.$reset();
      this.$refs.dateComponent.cleanFields()
    },
    cleanAllControls() {
      this.rfcToShow = "";
      this.rfcIsValid = false;
      this.email = "";
      this.requestTutor = false;
      this.tutor = "";
      this.documentName = "";
      this.base64File = "";
      this.list_beneficiaries = [];
      this.showFormAccess = true;
      this.$v.email.$reset();
      this.$v.tutor.$reset();
      this.cleanControlsBeneficiariesInModalWindow();
    },
    cancelModifyBeneficiarie() {
      this.cleanControlsBeneficiariesInModalWindow();
      this.showModalBeneficiaries = false
    },
    removeBeneficiarie(id){
      let index = this.list_beneficiaries.findIndex(b => b.id == id);

      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea eliminar el beneficiario?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.list_beneficiaries.splice(index,1);
          this.cleanControlsBeneficiariesInModalWindow();
          this.showModalBeneficiaries = false;
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    setIdAttributeToAccepAndCancelButtonSwalFire(idButtonConfirm, idButtonCancel) {
      $('.swal2-confirm').attr('id', idButtonConfirm);
      $('.swal2-cancel').attr('id', idButtonCancel);
    },
    changePercentage(value) {
      if (value.includes(".")) {
        value = parseFloat(value);
      }

      var value = parseInt(value);
      if (value < 1 || value > 100) {
        value = 0;
      }
      return value;
    },
    getTotalPercentage() {
      let sum = this.list_beneficiaries.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.porcentaje;
      }, 0)

      return sum;
    },
    getRemainingPercentage() {
      return (100 - this.getTotalPercentage());
    },
    register(e) {
      e.preventDefault();

      if (!this.isInvalidPrincipalForm()) {
        this.isLoading = true;
        let beneficiaries = this.createObjectBeneficiaries();

        this.beneficiarieObjectClass.register({
          token_auth: this.token_auth,
          rfc: this.rfcToShow,
          name: this.name,
          middle_name: "",
          paternal_name: this.paternalName,
          maternal_name: this.maternalName,
          tutor: this.tutor,
          email: this.email,
          beneficiaries_list_json: beneficiaries
        }).then(response => {
          console.log(response);
          Swal.fire({
            text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
            width: 600,
            html: `<p style="font-size:20px;font-weight:bold;">Solicitud de Actualización de Beneficiarios guardada correctamente</p><br/>
                  <p style="font-size:16px;">Para continuar con el proceso deberá imprimir la Solicitud de Actualización de Beneficiarios, 
                    una vez realizado esto vuelva a acceder con su RFC y NIP y adjunte el documento firmado.</p><br/><br/>
                  <p style="font-size:16px;">¿Desea que enviemos el documento de Solicitud de Actualización de Beneficiarios a su correo?</p>`,
            showCancelButton: true,
            confirmButtonText: "SI",
            cancelButtonText: "NO",
            allowOutsideClick: false,
            icon: "success",
          }).then((result)=>{
            if (result.value) {
              this.isLoading = true;
              let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Para continuar con el proceso deberá imprimir la Solicitud de Actualización de Beneficiarios, 
                  una vez realizado esto vuelva a acceder con su RFC y NIP y adjunte el documento firmado.`, 'http://200.92.206.58:90/beneficiaries/capture-beneficiaries');

              sendMailNotificationClient(this.email, "Notificación Solicitud Actualización de Beneficiarios", bodyEmail, response.data.response.url).then(response =>{
                this.isLoading = false;
                Swal.fire({
                  text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
                  html: `<p style="font-size:18px;font-weight:bold;">La Solicitud de Actualización de Beneficiarios se ha enviado a su correo.</p><br/>`,
                  confirmButtonText: "Continuar",
                  allowOutsideClick: false,
                  icon: "success",
                })
              }).catch(error => {
                this.isLoading = false;
                Swal.fire({
                  title: "Aviso",
                  text: error,
                  icon: "warning",
                })
              });
              this.cleanAllControls();
              this.$refs.accessComponent.cleanFields();
            } else {
              this.cleanAllControls();
              this.$refs.accessComponent.cleanFields();
            }
          });
          this.openLinkPdf(response.data.response.url);
        }).catch(error => {
          console.error(error)
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "warning",
          })
          this.isLoading = false;
        });
      }
    },
    createObjectBeneficiaries() {
      let objectBeneficiaries = {}
      let listBeneficiaries = [];

      for (let i = 0; i < this.list_beneficiaries.length; i++) {
        objectBeneficiaries = {
          name: this.list_beneficiaries[i].nombre,
          middle_name: "",
          paternal_name: this.list_beneficiaries[i].paterno,
          maternal_name: this.list_beneficiaries[i].materno,
          relationship: this.list_beneficiaries[i].parentesco,
          porcentage: this.list_beneficiaries[i].porcentaje,
          birth_date: this.list_beneficiaries[i].fecha_nacimiento
        }

        listBeneficiaries.push(objectBeneficiaries);
      }

      return listBeneficiaries;
    },
    validateEmail(email) {
      var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      if (regex.test(email)) {
        return true;
      }
      return false;
    },
    openLinkPdf(pdf) {
      try {
        var a = document.createElement('a');
        a.title = "Solicitud de actualización de Beneficiarios";
        a.target = "_blank";
        a.href = pdf;
        document.body.appendChild(a);
        a.click();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },
    getFile(selector) {
      document.getElementById(selector).value ="";
      document.getElementById(selector).click();
    },
    loadDocument(event) {
      let files = event.target.files;
      let filename = files[0].name.split('.')[0].replace(/\s/g, '_');
      let extension = files[0].type.split('/')[1];

      this.documentName = `${filename}.${extension}`;

      this.getFileReader(files, event);
    },
    getFileReader(files, event) {
      const fileReader = new FileReader();

      fileReader.addEventListener('load', () => {
        let fileBase64 = fileReader.result.split(',')[1];
        this.base64File = fileBase64;
        event.target.value = null;
      })
      fileReader.readAsDataURL(files[0]);
    },
    uploadFile() {
      if (this.base64File != "") {
        this.isLoading = true;
        this.beneficiarieObjectClass.uploadFile(this.token_auth, this.requestId, this.base64File).then(response => {
          console.log(response);
          this.isLoading = false;
          this.cleanAllControls();
          this.$refs.accessComponent.cleanFields();
          Swal.fire({
            text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
            width: 500,
            html: `<p style="font-size:20px;font-weight:bold;">El archivo de Solicitud de Actualización de Beneficiarios se cargó correctamente</p> <br/>
                    <p style="font-size:16px;">Todas las solicitudes capturadas a través de esta página, 
                  serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
            //this.$router.push({ name: 'HomeLoanRequest' });
          });
        }).catch(error => {
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "warning",
          })
          this.isLoading = false;
        }); 
      } else {
        Swal.fire({
          title: "Aviso",
          text: "Favor de cargar el documento de Solicitud Firmada",
          icon: "warning",
        })
      }
    },
    deleteDocument(){
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea eliminar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.documentName = "";
          this.base64File = "";
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    cancelRequest() {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea eliminar la solicitud?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.beneficiarieObjectClass.cancelRequest(this.token_auth, this.requestId).then(response => {
            console.log(response);
            this.isLoading = false;
            this.cleanAllControls();
            this.$refs.accessComponent.cleanFields();
            Swal.fire({
              text: "Solicitud de Actualización de Beneficiarios guardada correctamente",
              html: `<p style="font-size:18px;font-weight:bold;">La Solicitud de Actualización de Beneficiarios se eliminó correctamente</p>`,
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              icon: "success",
            }).then((response)=>{
            });
          }).catch(error => {
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "warning",
            })
            this.isLoading = false;
          });  
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    camelize(value) {
      if (value != "" && value != undefined) {
        let response = "";
        value = value.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function(match) {
          return match.charAt(match.length-1).toUpperCase();
        });
        response = value.charAt(0).toUpperCase() + value.substring(1);
        return response.replace(/([A-Z])/g, ' $1').trim(); 
      }

      return "";
    },
    getResponseDate(event) {
      this.birthdate_beneficiarie = event;
    },
    goBack() {
      this.cleanAllControls();
      this.$refs.accessComponent.cleanFields();
    },
  }
}
</script>